import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";
import { AppStore } from "..";
import { Icon } from "../../components/icons";
import { CenteredFlex } from "../../components/layout";
import { useCurrentStateAndParams } from "../../router";
// import quickSwapImg from "../../assets/quickswap.png";
import { colours } from "../../styles/colours";
import { BannerActions } from "./actions";
import { BannerState } from "./models";

const BannerContent = styled.a`
  font-weight: 700;
  text-transform: uppercase;
  color: inherit;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
`;

const Section = styled.a.attrs({ rel: "noreferrer", target: "_blank" })`
  ${CenteredFlex};
  /* width: 50%; */
  width: 100%;
  padding: 1.2em 0.8em;
`;

// const QuickswapContainer = styled(Section)`
//   background: rgb(44, 47, 54);
//   color: white;
//   padding-left: 0;
// `;

const UniswapContainer = styled(Section)`
  color: white;
  background: ${colours.blue};
  /* color: rgb(255 0 122);
  background: white; */
  padding-right: 0;
`;

const icon = css`
  margin-left: 1em;
  width: 1.5em;
  height: 1.5em;
`;

const TrustswapIcon = styled(Icon).attrs({ type: "trustswap" })`
  ${icon}
`;

// const QuickswapIcon = styled.img.attrs({ src: quickSwapImg })`
//   ${icon}
// `;

export const useBannerEffects = () => {
  const dispatch = useDispatch();
  const currentBanner = useSelector<AppStore, BannerState>(
    (store) => store.banner
  );
  const { state } = useCurrentStateAndParams();

  useEffect(() => {
    if (state.name?.includes("login")) {
      if (currentBanner === null) {
        dispatch(
          BannerActions.setBanner({
            children: (
              <Container>
                <UniswapContainer href="https://v2.info.uniswap.org/token/0x887168120cb89fb06f3e74dc4af20d67df0977f6">
                  <BannerContent>
                    {/* Get $SKRT: More Functionality and Rewards */}
                  </BannerContent>
                  {/* <TrustswapIcon /> */}
                </UniswapContainer>
                {/* <QuickswapContainer href="https://info.quickswap.exchange/pair/0xcfc4cbf94b26f94e86863e1b1f0ccae6f119dd5a">
                  <BannerContent>Get $SKRT Matic</BannerContent>
                  <QuickswapIcon />
                </QuickswapContainer> */}
              </Container>
            ),
          })
        );
      }
    } else if (currentBanner !== null) {
      dispatch(BannerActions.clearBanner());
    }
  }, [state]);
};
